import React from 'react'
import { DownloadAppForm } from '../Forms/DownloadAppForm';

export const FlexibleWork = ({
  title,
  body,
  landingPageStrings,
  sendAppLinkUrl,
}: {
  title: any;
  body: any;
  landingPageStrings: any;
  sendAppLinkUrl?: string;
}) => {
  return (
    <div className="jobs-flex lg:max-w-7xl m-auto pb-14 pt-10 lg:pb-24 lg:pt-32 flex flex-col lg:flex-row items-start justify-between text-cashew font-normal">
      <h2 className="lg:w-2/5 font-contrast font-normal text-hxl md:text-h2xl lg:pr-40 mb-4">{title}</h2>
      <div className="lg:w-3/5">
        {body.map((value, i) => {
        return (
          <p
            key={i}
            className="mb-4 text-sm lg:text-lg"
            dangerouslySetInnerHTML={{ __html: value }}
          />
        )
      })}
        {sendAppLinkUrl &&
          <DownloadAppForm
            sendAppLinkUrl={sendAppLinkUrl}
            invalidPhoneMessage={landingPageStrings.signupForm.validations.invalidPhone}
            successMessage={landingPageStrings.signupForm.validations.successMessage}
            requiredMessage={landingPageStrings.signupForm.validations.required}
          />
        }
      </div>
    </div>
  )
}
